import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_swiper_slide = _resolveComponent("swiper-slide");
    const _component_swiper = _resolveComponent("swiper");
    return (_openBlock(), _createBlock(_component_swiper, {
        autoplay: _ctx.options.autoplay,
        loop: _ctx.options.loop,
        speed: _ctx.options.speed,
        pagination: _ctx.options.pagination,
        loopedSlides: _ctx.options.loopedSlides,
        slidesPerView: _ctx.options.slidesPerView,
        centeredSlides: _ctx.options.centeredSlides,
        spaceBetween: _ctx.options.spaceBetween,
        ref: "swiperRef"
    }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, {
                    key: item.rowId,
                    onClick: ($event) => (_ctx.handleClick(item)),
                    "data-clipboard-text": item.code
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("img", {
                            src: item.image,
                            alt: ""
                        }, null, 8, _hoisted_1)
                    ]),
                    _: 2
                }, 1032, ["onClick", "data-clipboard-text"]));
            }), 128))
        ]),
        _: 1
    }, 8, ["autoplay", "loop", "speed", "pagination", "loopedSlides", "slidesPerView", "centeredSlides", "spaceBetween"]));
}
